import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuModule as SharedMenuModule } from '@nimbus-library/features/menu/menu.module';
import { MenuProviderService } from '@nimbus-portal/features/menu/services/menu-provider.service';
import { TitleProviderService } from '@nimbus-portal/features/menu/services/title-provider.service';
import { MenuAuthService } from '@nimbus-global/features/menu/services/menu-auth.service';
import { LoggingModule } from '@nimbus-library/features/logger/logging.module';
import { LogErrorHandler } from '@nimbus-library/features/logger/services/error-handler.service';
import { AggregatedLoggerService } from '@nimbus-library/features/logger/services/logger/aggregated-logger.service';
import { TeamSessionsService } from '@nimbus-portal/features/historical-sessions/services/team-sessions.service';
import { TeamSessionsApiClient } from '@nimbus-portal/features/historical-sessions/services/team-sessions.api-client';
import { UserSettingsModule } from '../user-settings/user-settings.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    UserSettingsModule,
    SharedMenuModule.forRoot(MenuProviderService, MenuAuthService, TitleProviderService),
    LoggingModule,
  ],
  exports: [SharedMenuModule, LoggingModule],
  providers: [AggregatedLoggerService, LogErrorHandler, TeamSessionsService, TeamSessionsApiClient],
})
export class MenuModule {}
